import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { setFontVariant } from "@similarweb/styles";

const { midnight, carbon } = colorsPalettes;

/**
 * We need to override the existing border design of the domains autocomplete
 * this was the best non-intrusive method for changing its style :(
 * NOTE: we want the bottom border to be blue when the user has focus on the autocomlete
 * AND when the autocomplete shows any results.
 */
export const EntitiesAutocompleteWrapper = styled.div`
    display: flex;
    flex-basis: 100%;

    .newDomainInput > div {
        border-radius: 3px;
        border: 1px solid ${midnight[50]};
    }
`;

const EntitiesAutocompleteContainer = styled.div`
    width: 100%;
`;

export const StyledAutocompletePlaceholder = styled(I18n)`
    padding-left: 32px;
    ${setFontVariant("input2", carbon[200])};
`;
